import React, { useCallback, useMemo } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Tappable } from '@vectord/components';
import orderBy from 'lodash/orderBy';

import {
  RESCHEDULE_CLASSES_STAGES,
  setRescheduleClassesStage,
  setSbatGroups,
  useFilteredRescheduleClasses,
  useGetSbatGroupListQuery,
} from 'features/classCreation';

function RescheduleButton({ sbatGroup }) {
  const dispatch = useDispatch();
  const { superBatchId } = useParams();
  const { data } = useGetSbatGroupListQuery(Number(superBatchId));

  const sbatGroups = useMemo(
    () =>
      orderBy(
        data.data.filter(
          (_sbatGroup) =>
            new Date(_sbatGroup.date_of_topic) >=
            new Date(sbatGroup.date_of_topic)
        ),
        (o) => new Date(o.date_of_topic),
        'asc'
      ),
    [data.data, sbatGroup.date_of_topic]
  );
  const filteredSbatGroups = useFilteredRescheduleClasses(sbatGroups);

  const handleReschedule = useCallback(() => {
    batch(() => {
      dispatch(setSbatGroups(filteredSbatGroups));
      dispatch(setRescheduleClassesStage(RESCHEDULE_CLASSES_STAGES.details));
    });
  }, [dispatch, filteredSbatGroups]);

  return (
    <Tappable
      className="link bold"
      noHighlight
      onClick={handleReschedule}
      disabled={sbatGroup.locked}
    >
      Reschedule
    </Tappable>
  );
}

export default RescheduleButton;
